import React from 'react'
import { Link } from '@inertiajs/react'
import styles from './SidebarLink.module.scss'

interface SidebarLinkProps {
  href: string
  children: React.ReactNode
  className?: never
}

export const SidebarLink: React.FC<SidebarLinkProps> = ({ href, children }) => (
  <Link href={href} className={styles.link}>{children}</Link>
)
